import styled from 'styled-components';

export const EmbedPlaceholderContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => `${theme.palette.grayscale.black}cc`};
    color: ${({ theme }) => theme.palette.grayscale.white};
    font-weight: bold;
    gap: 0.5rem;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const EmbedPlaceholderButton = styled.button`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.palette.primary.main};
    }
`;
